import { render, staticRenderFns } from "./masterHr.vue?vue&type=template&id=4c6fadf3"
import script from "./masterHr.vue?vue&type=script&lang=js"
export * from "./masterHr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports